var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandPlusOutlinedFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66699C5.4088 1.66699 1.66797 5.40782 1.66797 10.0003C1.66797 14.5928 5.4088 18.3337 10.0013 18.3337C14.5938 18.3337 18.3346 14.5928 18.3346 10.0003C18.3346 5.40782 14.5938 1.66699 10.0013 1.66699ZM10.0013 3.33366C13.6931 3.33366 16.668 6.30856 16.668 10.0003C16.668 13.6921 13.6931 16.667 10.0013 16.667C6.30953 16.667 3.33464 13.6921 3.33464 10.0003C3.33464 6.30856 6.30953 3.33366 10.0013 3.33366ZM10.0013 5.83366C9.54107 5.83366 9.16797 6.20676 9.16797 6.66699V9.16699H6.66797C6.20773 9.16699 5.83464 9.54009 5.83464 10.0003C5.83464 10.4606 6.20773 10.8337 6.66797 10.8337H9.16797V13.3337C9.16797 13.7939 9.54107 14.167 10.0013 14.167C10.4615 14.167 10.8346 13.7939 10.8346 13.3337V10.8337H13.3346C13.7949 10.8337 14.168 10.4606 14.168 10.0003C14.168 9.54009 13.7949 9.16699 13.3346 9.16699H10.8346V6.66699C10.8346 6.20675 10.4615 5.83366 10.0013 5.83366Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandPlusOutlinedFigma);
export default __webpack_public_path__ + "static/media/expand-plus-outlined-figma.f88f2b234db288d9fe6de7fee892aef3.svg";
export { ForwardRef as ReactComponent };